import { OnInit, OnDestroy } from '@angular/core'
import { Component } from '@angular/core'
import { Subscription, interval } from 'rxjs'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { LiveUserAuthority } from 'src/lib/entity/live-user-authority'
import {
  RevenueHistoriesForMonth,
  ChangePageRequest,
} from 'src/lib/entity/revenue'
import { Magazine } from 'src/lib/entity/magazine'
import { ConsoleLogger } from 'src/lib/console-logger'
import { environment } from 'src/env/environment'

@Component({
  templateUrl: './revenue-manage-page.component.html',
  styleUrls: ['./revenue-manage-page.component.scss'],
})
export class RevenueManagePageComponent implements OnInit, OnDestroy {
  /* Subscription */
  private getMagazineSub: Subscription | undefined
  private getAuthoritySub: Subscription | undefined

  authority: LiveUserAuthority | undefined
  baseURL = environment.baseURL
  loginCallbackURL =
    environment.baseURL.mag2mypage + 'Welcome.do?ref=' + window.location.href

  /* ログインセッションが30分で切れてしまうため、視聴画面から定期ポーリングする対応 */
  private authorityPollingMillis: number = 1000 * 60 * 10 // 10分
  private authorityPollingTimer: Subscription

  /* メンテナンスページ用 */
  isMaintenance: Boolean = false

  /* 収益管理用 */
  revenueHistoriesForMonth: RevenueHistoriesForMonth | 'NOT_FOUND'

  isShowMagazineIndexPage: boolean = true
  isShowRevenueIndexPage: boolean = false
  isShowRevenueDetailPage: boolean = false

  magazineList: Magazine[] = []
  yearMonth: string
  selectedMagazineId: number

  constructor(private logger: ConsoleLogger) {}

  ngOnInit() {
    this.getAuthoritySub = MagliveApiClient.getAuthority().subscribe(
      (authorities) => {
        // 未ログインなのでログインページにリダイレクト
        if (authorities === 'NOT_LOGIN') {
          window.location.href = this.loginCallbackURL
          return
        }
        if (authorities.status === 503) {
          this.isMaintenance = true
        }
        if (authorities !== 'NOT_LOGIN') {
          this.authority = authorities
          this.getMagazineList(this.authority)
        } else {
          this.authorityPollingTimer = interval(
            this.authorityPollingMillis
          ).subscribe(() => {
            this.getAuthoritySub = MagliveApiClient.getAuthority().subscribe(
              (newAuthorities) => {
                if (newAuthorities === 'NOT_LOGIN') {
                  // 非ログイン状態になったら非有効化
                  this.authorityPollingTimer.unsubscribe()
                }
              }
            )
          })
        }
      }
    )
  }

  ngOnDestroy(): void {
    if (this.authorityPollingTimer) {
      this.authorityPollingTimer.unsubscribe()
    }
    if (this.getMagazineSub) {
      this.getMagazineSub.unsubscribe()
    }
    if (this.getAuthoritySub) {
      this.getAuthoritySub.unsubscribe()
    }
  }

  /**
   * マガジンの一覧を取得する
   */
  private getMagazineList(authority: LiveUserAuthority) {
    const magazineIds = authority.publishingReleasedPaymentMagazineIds
    if (magazineIds.length !== 0) {
      for (let i = 0; i < magazineIds.length; i++) {
        this.getMagazineSub = MagliveApiClient.getMagazine(
          magazineIds[i]
        ).subscribe((value) => {
          if (value !== 'NOT_FOUND') {
            this.magazineList.push(value)
          }
        })
      }
      this.logger.info(
        this.constructor.name,
        'getMagazineList',
        'magazineList',
        this.magazineList
      )
    }
  }

  /**
   * ページの表示切替
   */
  changePage(request: ChangePageRequest): void {
    if (request.name === 'MAGAZINE_LIST') {
      this.isShowMagazineIndexPage = true
      this.isShowRevenueIndexPage = false
      this.isShowRevenueDetailPage = false
    } else if (request.name === 'HISTORY_ALL') {
      // 収益一覧画面への切り替え
      this.selectedMagazineId = request.magazineId
      this.isShowMagazineIndexPage = false
      this.isShowRevenueIndexPage = true
      this.isShowRevenueDetailPage = false
    } else if (request.name === 'DETAIL') {
      // 収益詳細画面への切り替え
      this.yearMonth = request.yearMonth
      this.isShowMagazineIndexPage = false
      this.isShowRevenueIndexPage = false
      this.isShowRevenueDetailPage = true
    }
  }
}
